/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Grid,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { required } from '@mhub/web-validations';
import AppForm from '../AppForm';
import { PROJECT_UNIT_PACKAGE_FEE_DEFAULT } from '../../structs/additional_fee';
import { namespaces } from '../../constants/translation';

class UnitPackageFeeEdit extends Component {
  static propTypes = {
    data: PropTypes.shape(),
    onChange: PropTypes.func,
    feePackages: PropTypes.func,
    refForm: PropTypes.func,
    refValidation: PropTypes.func,
    t: PropTypes.func,
  }
  static defaultProps = {
    data: Object.assign({}, PROJECT_UNIT_PACKAGE_FEE_DEFAULT),
  }
  handleSave = (e) => {
    if (e) e.preventDefault();
    const { data } = this.props;
    if (this.props.onChange) this.props.onChange(data);
  }
  handleInputChange = (e, d) => {
    const { data } = this.props;
    data[d.name] = d.value;
    if (this.props.onChange) this.props.onChange(data);
  }
  handleCheckboxChange = (e, d) => {
    const { data } = this.props;
    data[d.name] = !data[d.name];
    if (data[d.name]) {
      if (data.id === '') data.projectFeePackageID = '';
      data.totalPrice = '';
    }
    if (this.props.onChange) this.props.onChange(data);
  }
  render() {
    const { data, t } = this.props;
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <AppForm
              as="div"
              onSubmit={this.handleSave}
              ref={this.props.refForm}
            >
              <Grid>
                <Grid.Row verticalAlign="middle" className="row_enable_package_custom_price">
                  <Grid.Column mobile={16} tablet={12} computer={13}>
                    {(data.id !== '' && data.projectFeePackageID !== '') ?
                      <span>
                        <span className="text_name">{data.projectFeePackage.name}{data.projectFeePackage.description !== '' ? ': ' : ''}</span>
                        {data.projectFeePackage.description !== '' ? <span className="text_description">{data.projectFeePackage.description}</span> : ''}
                      </span>
                      : ''
                    }
                    <AppForm.Validate
                      name="projectFeePackageID"
                      onChange={this.handleInputChange}
                      ref={this.props.refValidation}
                      validateLabel={t('Additional Fee Package')}
                      validation={data.id === '' ? [required] : null}
                      style={data.id === '' ? {} : { display: 'none' }}
                    >
                      <Form.Select
                        fluid
                        name="projectFeePackageID"
                        options={this.props.feePackages()}
                        placeholder={t('Select Additional Fee Package')}
                        search
                        selectOnBlur
                        value={data.projectFeePackageID}
                      />
                    </AppForm.Validate>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </AppForm>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default withTranslation(namespaces)(UnitPackageFeeEdit);



// WEBPACK FOOTER //
// ./src/components/ProjectUnitPackageFee/UnitPackageFeeEdit.jsx